import regularExpressions from '../constants/regular-expressions';

const hasGlobals = (html) => regularExpressions.WS_GLOBAL.test(html);

export default hasGlobals;
